import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";

export const selectAuthErrorHandling = createSelector([(state: AppState) => state.shared.authErrorHandling], ({ error }) => ({ error }));
